import { render, staticRenderFns } from "./ReturnStep.vue?vue&type=template&id=c28d2660&scoped=true&"
import script from "./ReturnStep.vue?vue&type=script&lang=ts&"
export * from "./ReturnStep.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnStep.vue?vue&type=style&index=0&id=c28d2660&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28d2660",
  null
  
)

export default component.exports